import type React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { WorkflowSandbox } from "../components/Workflow/WorkflowSandbox";

const SandboxPage: React.FC = () => {
  const urlParams = useParams();

  const [title, setTitle] = useState<string>("new");

  useEffect(() => {
    setTitle(urlParams.id || "new");
  });

  return <WorkflowSandbox id={urlParams.id || ""} />;
};

export default SandboxPage;
